export default "assets/images/quote-texture-4b32639e.png";